import { render, staticRenderFns } from "./BrandArchitectureStep3.vue?vue&type=template&id=51b15aa0&scoped=true&"
import script from "./BrandArchitectureStep3.vue?vue&type=script&lang=js&"
export * from "./BrandArchitectureStep3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b15aa0",
  null
  
)

export default component.exports